import axios from "axios";

// Initial base URLs from env
const client_base_url = process.env.REACT_APP_CLIENT_BASE_URL;
const base_url = process.env.REACT_APP_BASE_URL;
const saas_api_urll = process.env.REACT_APP_SAAS_API_URL;
let s3_base_url = process.env.REACT_APP_S3_BASE_URL || "https://saas-gamerji-uploads.s3.amazonaws.com"; // Fallback
const eass_url = process.env.REACT_APP_CLIENT_BASE_URL;
// URL object (exported immediately)
export const url = {
  apiUrl: base_url + "api/web/",
  saasApiUrl: saas_api_urll + "api/",
  publicUrl: base_url + "api/public/",
  imageUrl: s3_base_url + "/", // Initial value; will be updated dynamically
  gamesUrl: saas_api_urll + "api/game/",
  gamesTypesUrl: saas_api_urll + "api/gameType/",
  apiUrlV2: base_url + "api/v2/",
  scrim_url: saas_api_urll + "api/v2/scrim/",
  saasApiUrlV2: saas_api_urll + "api/v2/",
  client_base_url:client_base_url,
  saasApiD11Url: saas_api_urll + "api/web/",
  authUrl: base_url + "api/auth/",
};

// Fetch and update the image URL dynamically after load
(async () => {
  try {
    const response = await axios.get(`https://api.gamerji.tech/api/bucket/url`);
    if (response?.data?.url) {
      url.imageUrl = response.data.url + "/"; // ✅ Update the exported url object directly
      console.log("S3 Base URL updated:", url.imageUrl);
    }
  } catch (error) {
    console.error("Error fetching S3 base URL:", error?.response?.data?.message || error.message);
  }
})();
